<template>
	<button
		v-if="$route.name === 'list-process'"
		large
		class="mt-1 btn-clear"
		:style="`border:solid 1px ${$appColors.error};color:${$appColors.error}`"
		@click="$emit('click')"
	>
		{{value}}
	</button>
	<button
		v-else-if="$route.name === 'process-choose-evaluators'"
		large
		class="mt-1 btn-clear"
		:style="`border:solid 1px ${$appColors.primary};color:${$appColors.primary}`"
		@click="$emit('click')"
	>
		{{value}}
	</button>
	<button
		v-else
		large
		class="mt-1 btn-clear"
		:style="`border:solid 1px ${$appColors.secondary};color:${$appColors.secondary}`"
		@click="$emit('click')"
	>
		{{value}}
	</button>  
</template>

<script>
export default {
	name: 'button-clear',
	props: {
		value: {
			default: '',
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-clear {
	border-radius: 4px;
	height: 31px;
	width: 111px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/button-clear.vue